import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolGetStartedStepTwo = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.gettingStarted.explanations.title.step1')}
          </h2>
          <div className="sm:mt-8 sm:mb-8 block sm:hidden">
            <Image
              width={300}
              height={208}
              className="flex-image"
              src="/images/sign_up_en.png"
              alt="Sign up Image"
            />
          </div>
          <p
            className="school-section-description"
            dangerouslySetInnerHTML={{
              __html: t(
                'service.school.gettingStarted.explanations.detail.step1',
              ),
            }}
          />
        </div>
        <div className="order-first md:order-last col-span-12 lg:col-span-5 md:col-span-6 hidden sm:block">
          <Image
            width={300}
            height={208}
            className="flex-image"
            src="/images/sign_up_en.png"
            alt="Sign up Image"
          />
        </div>
      </div>
    </div>
  );
};

export default SchoolGetStartedStepTwo;
